import { render, staticRenderFns } from "./dangerousGoodProofAction.vue?vue&type=template&id=50468722"
import script from "./dangerousGoodProofAction.vue?vue&type=script&lang=js"
export * from "./dangerousGoodProofAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports